import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  routingNumberTitle: {
    defaultMessage: 'Routing Number',
    id: 'us_routing_number_title',
    description: 'US routing number field title',
  },
  routingNumberError: {
    defaultMessage: 'This is 9 digits.',
    id: 'us_routing_number_error',
    description: 'US routing number field error message',
  },
  accountNumberTitle: {
    defaultMessage: 'Account Number',
    id: 'n8n0/+',
    description: 'Account number field title',
  },
  accountNumberError: {
    defaultMessage: 'This is between 8 and 17 digits.',
    id: 'us_account_number_error',
    description: 'US account number field error message',
  },
  bankNameTitle: {
    defaultMessage: 'Bank Name',
    id: 'us_bank_name_title',
    description: 'US bank name field title',
  },
});
